import { IRequest } from '../../httpClient/serverApi/types/IRequest';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { IUserNotificationSetting } from '../models/IUserNotificationsSettingsInfo';
import { UserNotificationSettingsLayer } from '../models/UserNotificationSettingsLayer';
import { GetUserNotificationSettingsRequest } from '../redux/serverRequests/GetUserNotificationSettingsRequest';
import { IGetUserNotificationSettingsResponse } from '../redux/serverRequests/IGetUserNotificationSettingsResponse';
import { UpdateNotificationSettingsRequest } from '../redux/serverRequests/UpdateNotificationSettingsRequest';

/**
 * API for user notification settings management.
 * See: https://mytableau.tableaucorp.com/display/devscale/List+of+Administration+API+for+Notification+Settings
 */
export namespace UserNotificationSettingsService {

  export function getUserNotificationsSettings(layer: UserNotificationSettingsLayer, siteId?: string): Promise<IGetUserNotificationSettingsResponse> {
    return sendRequest(new GetUserNotificationSettingsRequest(layer, siteId));
  }

  export function updateNotificationSettings(layer: UserNotificationSettingsLayer, updatedSettings: IUserNotificationSetting[], siteId?: string): Promise<void> {
    return sendRequest(new UpdateNotificationSettingsRequest(layer, updatedSettings, siteId));
  }

  function sendRequest<TParams, TResult>(request: IRequest<TParams, TResult>): Promise<TResult> {
    return WebHttpClient.sendRequest(request);
  }

}
